export function getDateAsISOStringWithoutTimeZoneOffset(date: Date): string {
  const timezoneOffset: number = date.getTimezoneOffset() * 60000; //offset in milliseconds
  const localISOTime = new Date(date.getTime() - timezoneOffset).toISOString();

  return localISOTime;
}
